// extracted by mini-css-extract-plugin
export default {"inputsContainer":"Step1__inputsContainer___E7lim","inputContainer":"Step1__inputContainer___AqO_R"};